import {
    CheckHomeworkMaxTextLength,
    CheckHomeworkPictureIcon, CheckHomeworkSaveButton,
    CheckHomeworkTextarea,
    CheckHomeworkСomment, CommentImage, CommentImageList,
    RecommendationsList,
    RecommendationWrapper
} from "./styles";
import PictureIcon from "../../icons/PictureIcon";
import {FC, useCallback, useEffect, useRef, useState} from "react";
import {API, Endpoints} from "@brg/api";
import {useProfile} from "@brg/auth";
import {FlexBox, useToasts} from "@brg/ui";
import {CommentHomeworkList} from "./commentHomeworkList";
import {useUppyLoader} from "../../hooks/useUppyLoader";
import CloseIcon from "../../icons/CloseIcon";
import {uploadValidator} from "../../helpers/utils/uploadValidator";
import {pasteCommentImages} from "shared/helpers/pasteCommentImages";

export const CommentHomework: FC<{postId: string}> = ({postId}) => {

    const fileRef = useRef<HTMLInputElement>(null);
    const [files, setFiles] = useState<File[]>([]);
    const [time, setTime] = useState(Date.now());
    const [currentText, setCurrentText] = useState('');
    const element = useRef<HTMLTextAreaElement>(null)
    const toasts = useToasts()

    const profile = useProfile();

    const onUploadComplete = useCallback(() => {}, []);

    const addImages = useCallback(async (newFiles: File[]) => {
        if (!newFiles.length) return;

        const multipleFilesCheckResult = await Promise.all(
            newFiles.map(img => uploadValidator([img], toasts, false, profile))
        );
        const allowed = await uploadValidator(files, toasts, false, profile)

        if (!allowed || multipleFilesCheckResult?.includes(false)) {
            return
        }

        setTime(Date.now());
        setTimeout(() => {
            setFiles(prev => [...(prev || []), ...newFiles]);
        }, 0)
    } , [files, toasts, profile])

    const onAddImage = (event: React.ChangeEvent<HTMLInputElement>) => {
        const images = Array.from(event.target.files || []);
        event.target.value = "";
        void addImages(images);
    };

    const onRemoveImage = useCallback((name: string) => {
        setFiles(files.filter(file => file.name !== name))
        setTime(Date.now())
    } , [files])

    const [, data] = useUppyLoader( files, fileRef, onUploadComplete, time );
    const [t, setT] = useState(Date.now())

    const onSave = useCallback(() => {

        setCurrentText("")
        setFiles([])
        setTime(Date.now())

        API.request()
            .endpoint(Endpoints.gateway)
            .url(`message/api/comment/Add`)
            .post()
            .body({
                entityId: postId,
                entityType: "post",
                accountId: profile?.accountId,
                text: currentText,
                ...((data?.length > 0) ? { attachments: data.map(file => ({files: [{ fileId: file?.id }]})) } : {})
            })
            .release()
            .then((r) => r.json)
            .then((r) => {
                setTimeout(() => setT(Date.now()), 1000)
            })
    } , [currentText, postId, profile, data])

    const resize = useCallback(() => {

        if (!element?.current) return;

        element.current.style.height = "5px";
        element.current.style.height = (element.current.scrollHeight < 72 ? 72 : element.current.scrollHeight) +"px";
    }, [currentText, element.current?.scrollHeight]);

    useEffect(() => {
        resize()
    }, [resize])

    return <FlexBox direction="column" directionMobile="column" gy={24}>
        <CommentHomeworkList postId={postId} t={t}/>
        <CheckHomeworkСomment>
            <CheckHomeworkTextarea
                ref={element}
                placeholder={'Напишите комментарий студенту'}
                value={currentText}
                onChange={e => setCurrentText(e.target.value)}
                onPaste={event => pasteCommentImages(event, addImages)}
                maxLength={800}
            />
            <CheckHomeworkPictureIcon>
                <PictureIcon
                    fill='#909090'
                />
                <input
                    type='file'
                    accept='image/jpeg, image/gif, image/png'
                    multiple={true}
                    ref={fileRef}
                    onChange={(e) => {
                        onAddImage(e)
                    }}
                />
            </CheckHomeworkPictureIcon>
            <CommentImageList>
                {data.map(item => item.src && <FlexBox gx={16} key={item.id}>
                    <CommentImage src={item?.src} alt='big' />
                    <CloseIcon onClick={() => onRemoveImage(item?.name)}/>
                </FlexBox>)}
            </CommentImageList>
            <CheckHomeworkMaxTextLength>{currentText?.length}/800</CheckHomeworkMaxTextLength>
        </CheckHomeworkСomment>
        <FlexBox direction="column" justify="space-between">
            <RecommendationWrapper direction="column">
                <div>Рекомендуемая структура</div>
                <RecommendationsList>
                    <li>Сильные стороны</li>
                    <li>Что доработать</li>
                    <li>Следующие шаги</li>
                </RecommendationsList>
            </RecommendationWrapper>
            <CheckHomeworkSaveButton onClick={onSave}>Сохранить</CheckHomeworkSaveButton>
        </FlexBox>
    </FlexBox>
}import {
    CheckHomeworkMaxTextLength,
    CheckHomeworkPictureIcon, CheckHomeworkSaveButton,
    CheckHomeworkTextarea,
    CheckHomeworkСomment, CommentImage, CommentImageList,
    RecommendationsList,
    RecommendationWrapper
} from "./styles";
import PictureIcon from "../../icons/PictureIcon";
import {FC, useCallback, useEffect, useRef, useState} from "react";
import {API, Endpoints} from "@brg/api";
import {useProfile} from "@brg/auth";
import {FlexBox, useToasts} from "@brg/ui";
import {CommentHomeworkList} from "./commentHomeworkList";
import {useUppyLoader} from "../../hooks/useUppyLoader";
import CloseIcon from "../../icons/CloseIcon";
import {uploadValidator} from "../../helpers/utils/uploadValidator";
import {pasteCommentImages} from "shared/helpers/pasteCommentImages";

export const CommentHomework: FC<{postId: string}> = ({postId}) => {

    const fileRef = useRef<HTMLInputElement>(null);
    const [files, setFiles] = useState<File[]>([]);
    const [time, setTime] = useState(Date.now());
    const [currentText, setCurrentText] = useState('');
    const element = useRef<HTMLTextAreaElement>(null)
    const toasts = useToasts()

    const profile = useProfile();

    const onUploadComplete = useCallback(() => {}, []);

    const addImages = useCallback(async (newFiles: File[]) => {
        if (!newFiles.length) return;

        const multipleFilesCheckResult = await Promise.all(
            newFiles.map(img => uploadValidator([img], toasts, false, profile))
        );
        const allowed = await uploadValidator(files, toasts, false, profile)

        if (!allowed || multipleFilesCheckResult?.includes(false)) {
            return
        }

        setTime(Date.now());
        setTimeout(() => {
            setFiles(prev => [...(prev || []), ...newFiles]);
        }, 0)
    } , [files, toasts, profile])

    const onAddImage = (event: React.ChangeEvent<HTMLInputElement>) => {
        const images = Array.from(event.target.files || []);
        event.target.value = "";
        void addImages(images);
    };

    const onRemoveImage = useCallback((name: string) => {
        setFiles(files.filter(file => file.name !== name))
        setTime(Date.now())
    } , [files])

    const [, data] = useUppyLoader( files, fileRef, onUploadComplete, time );
    const [t, setT] = useState(Date.now())

    const onSave = useCallback(() => {

        setCurrentText("")
        setFiles([])
        setTime(Date.now())

        API.request()
            .endpoint(Endpoints.gateway)
            .url(`message/api/comment/Add`)
            .post()
            .body({
                entityId: postId,
                entityType: "post",
                accountId: profile?.accountId,
                text: currentText,
                ...((data?.length > 0) ? { attachments: data.map(file => ({files: [{ fileId: file?.id }]})) } : {})
            })
            .release()
            .then((r) => r.json)
            .then((r) => {
                setTimeout(() => setT(Date.now()), 1000)
            })
    } , [currentText, postId, profile, data])

    const resize = useCallback(() => {

        if (!element?.current) return;

        element.current.style.height = "5px";
        element.current.style.height = (element.current.scrollHeight < 72 ? 72 : element.current.scrollHeight) +"px";
    }, [currentText, element.current?.scrollHeight]);

    useEffect(() => {
        resize()
    }, [resize])

    return <FlexBox direction="column" directionMobile="column" gy={24}>
        <CommentHomeworkList postId={postId} t={t}/>
        <CheckHomeworkСomment>
            <CheckHomeworkTextarea
                ref={element}
                placeholder={'Напишите комментарий студенту'}
                value={currentText}
                onChange={e => setCurrentText(e.target.value)}
                onPaste={event => pasteCommentImages(event, addImages)}
                maxLength={800}
            />
            <CheckHomeworkPictureIcon>
                <PictureIcon
                    fill='#909090'
                />
                <input
                    type='file'
                    accept='image/jpeg, image/gif, image/png'
                    multiple={true}
                    ref={fileRef}
                    onChange={(e) => {
                        onAddImage(e)
                    }}
                />
            </CheckHomeworkPictureIcon>
            <CommentImageList>
                {data.map(item => item.src && <FlexBox gx={16} key={item.id}>
                    <CommentImage src={item?.src} alt='big' />
                    <CloseIcon onClick={() => onRemoveImage(item?.name)}/>
                </FlexBox>)}
            </CommentImageList>
            <CheckHomeworkMaxTextLength>{currentText?.length}/800</CheckHomeworkMaxTextLength>
        </CheckHomeworkСomment>
        <FlexBox direction="column" justify="space-between">
            <RecommendationWrapper direction="column">
                <div>Рекомендуемая структура</div>
                <RecommendationsList>
                    <li>Сильные стороны</li>
                    <li>Что доработать</li>
                    <li>Следующие шаги</li>
                </RecommendationsList>
            </RecommendationWrapper>
            <CheckHomeworkSaveButton onClick={onSave}>Сохранить</CheckHomeworkSaveButton>
        </FlexBox>
    </FlexBox>
}